// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.with-opacity {
  opacity: 0.3;
}
.facebook-logo {
  fill: #3b5998;
}
.facebook-logo-color {
  fill: #4267b2;
}
.twitter-logo-color {
  fill: #1da1f2;
}
.youtube-logo-color {
  fill: #fc0d1c;
}
.linkedin-logo-color {
  fill: #0077b5;
}
.wechat-logo-color {
  fill: #51c332;
}
.activation-email {
  text-align: right;
}
.activation-email-collapse {
  text-align: left;
}
.btn + .btn.activation-email-button {
  margin-left: 0.8rem !important;
}
.resend-email-button {
  background-color: #ffffff;
  border: solid 1px #a2a2a2;
  color: #337ab7;
  font-size: 14px;
}
.resend-email-button i {
  font-size: 18px;
}
.resend-email-button:hover {
  background-color: #e2e6ea;
}
.social-media-logo-container {
  margin-top: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.social-media-logo-container .social-media-logo {
  display: inline-block;
  width: calc(100% * (1/3));
  margin-bottom: 2em;
}
@media (max-width: 992px) and (min-width: 768px) {
  .social-media-logo-container .social-media-logo {
    width: calc(100% * (1/6));
  }
}
.relative,
.editable-container {
  position: relative;
}
.border {
  border: 1px solid #dddddd;
}
.darkBorder {
  border: 1px solid #dddddd;
  border-color: #dddddd;
}
.darkBorderBottom {
  border-bottom: 1px solid #dddddd;
}
.darkBorderTop {
  border-top: 1px solid #dddddd;
}
.h2 {
  margin-bottom: 0.5em;
}
.multilineOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.singleLineOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.twoLinesOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.threeLinesOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.fourLinesOverflow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.verticalMiddle {
  display: inline-block;
  vertical-align: middle;
}
.verticalTop {
  display: inline-block;
  vertical-align: top;
}
.algolia-error {
  display: block;
  padding: 2em;
  background: #fbeddc;
  text-align: center;
  color: #FF0000;
}
.submitting {
  opacity: 0.6;
}
[type='file']::-webkit-file-upload-button {
  -webkit-appearance: button;
}
.absolute-stretch {
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0px;
  right: 0px;
}
.absolute-vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.tag-list.participants {
  padding: 0px;
  margin: 0px;
}
.tag-list.participants > li {
  display: inline-block;
  vertical-align: top;
  padding: 0px 10px;
  background: #dddddd;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #dddddd;
  border-color: #dddddd;
}
.file-upload {
  overflow: hidden;
}
.file-upload .file-upload-wrapper {
  position: relative;
}
.file-upload .file-upload-wrapper .fa,
.file-upload .file-upload-wrapper .fa-solid,
.file-upload .file-upload-wrapper .fa-regular,
.file-upload .file-upload-wrapper .fa-light,
.file-upload .file-upload-wrapper .fa-brands {
  padding: 8px 7px;
  cursor: pointer;
}
.file-upload .file-upload-wrapper input[type='file'] {
  display: none;
}
.file-upload .file-upload-wrapper .fa-camera,
.file-upload .file-upload-wrapper .fa-upload {
  vertical-align: top;
  font-size: 2.4rem;
}
.profile-image .image-container.editable {
  position: relative;
}
.profile-image .file-upload {
  position: absolute;
  right: 2px;
  bottom: 14px;
  top: auto;
  font-size: 2.5rem;
  color: white;
  border-radius: 3px;
}
.profile-image .spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0px;
  background: none;
  border: none;
}
.stretchable-spinner {
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0px;
  right: 0px;
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid gray;
}
.stretchable-spinner .spinner {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0px;
  background: none;
  border: none;
}
.logged-in-user-settings {
  text-align: center;
  margin-bottom: 15px;
  padding: 20px 20px 20px 20px;
}
.logged-in-user-settings > li {
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  padding: 0 0.7em;
}
.logged-in-user-settings > li nav,
.logged-in-user-settings > li a {
  display: block;
  min-height: auto;
}
.logged-in-user-settings > li,
.logged-in-user-settings > li a,
.logged-in-user-settings > li span {
  color: inherit;
}
.logged-in-user-settings > li span {
  display: inline-block;
  vertical-align: middle;
  font-size: 2rem;
  font-weight: 400;
}
@media (max-width: 768px) {
  .logged-in-user-settings {
    text-align: left;
  }
  .logged-in-user-settings > li {
    display: block;
    padding: 0.7em;
    color: inherit;
  }
}
.settings-navbar-list .logged-in-user-settings__base {
  position: relative;
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
}
.settings-navbar-list .logged-in-user-settings__welcome {
  display: block;
  font-size: 25px;
}
@media (min-width: 768px) {
  .settings-navbar-list .logged-in-user-settings__welcome {
    flex-grow: 2;
    width: auto;
  }
}
.settings-navbar-list .logged-in-user-settings__list {
  list-style: none;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
@media (min-width: 768px) {
  .settings-navbar-list .logged-in-user-settings__list {
    width: auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}
.settings-navbar-list .logged-in-user-settings__item {
  padding-left: 10px;
}
.settings-navbar-list .logged-in-user-settings__item:not(:last-child):after {
  content: "";
  border-right: 1px solid gray;
}
@media (min-width: 768px) {
  .settings-navbar-list .logged-in-user-settings__item:last-child:after {
    content: "";
    border-right: 1px solid gray;
  }
}
.settings-navbar-list .logged-in-user-settings__link {
  white-space: nowrap;
  font-size: 15px;
}
.settings-navbar-list .logged-in-user-settings__link--logout {
  padding-left: 10px;
}
@media (min-width: 768px) {
  .settings-navbar-list .logged-in-user-settings__link--logout {
    order: 3;
  }
}
.settings-navbar-list .logged-in-user-settings__label {
  padding-left: 10px;
  padding-right: 10px;
}
.settings-dropdown {
  position: relative;
}
.settings-dropdown .logged-in-user-settings__dropdown-base {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 250px;
}
@media (max-width: 480px) {
  .settings-dropdown .logged-in-user-settings__dropdown-base {
    width: 100%;
    position: relative;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-list {
  list-style: none;
  padding-left: 0;
  padding-right: 0;
  width: 250px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-end;
  color: white;
  border-radius: 0 0 4px 4px;
}
.settings-dropdown .logged-in-user-settings__dropdown-list__hide {
  display: none;
}
@media (min-width: 768px) {
  .settings-dropdown .logged-in-user-settings__dropdown-list {
    width: auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}
@media (max-width: 480px) {
  .settings-dropdown .logged-in-user-settings__dropdown-list {
    width: 100%;
    border-radius: 0;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-item {
  padding-left: 15px;
  width: 250px;
  margin-bottom: 10px;
}
.settings-dropdown .logged-in-user-settings__dropdown-item:first-child {
  margin-top: 15px;
}
.settings-dropdown .logged-in-user-settings__dropdown-item:not(:last-child):after {
  content: '';
  display: block;
  border-bottom: 1px solid white;
  width: 220px;
  height: 1px;
  margin-top: 10px;
}
@media (max-width: 480px) {
  .settings-dropdown .logged-in-user-settings__dropdown-item:not(:last-child):after {
    width: 95%;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-item span {
  color: white;
}
@media (min-width: 768px) {
  .settings-dropdown .logged-in-user-settings__dropdown-item:last-child:after {
    content: "";
  }
}
@media (max-width: 480px) {
  .settings-dropdown .logged-in-user-settings__dropdown-item {
    width: 100%;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-link {
  white-space: nowrap;
  font-size: 15px;
}
.settings-dropdown .logged-in-user-settings__dropdown-link--logout {
  padding-left: 0px;
}
@media (min-width: 768px) {
  .settings-dropdown .logged-in-user-settings__dropdown-link--logout {
    order: 3;
  }
}
.settings-dropdown .logged-in-user-settings__dropdown-label {
  padding-left: 10px;
  padding-right: 10px;
  color: white;
}
.participant-dropdown-image img {
  border: 1px solid #dddddd;
  border-radius: 180px;
  width: 30px;
  height: 30px;
  max-width: 30px !important;
}
.participant-dropdown-text {
  color: white;
  width: 100%;
  height: 18px;
  margin: 6.5px 35.5px 5.5px 10px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (min-width: 768px) {
  .participant-dropdown-text {
    flex-grow: 2;
    width: auto;
  }
}
.participant-dropdown-container {
  display: flex;
  flex-direction: row;
  width: 250px;
  height: 43px;
  padding: 5px 10.5px 10px 15px;
  object-fit: contain;
  border-radius: 4px 4px 4px 4px;
  position: relative;
  cursor: pointer;
}
@media (max-width: 480px) {
  .participant-dropdown-container {
    width: 100%;
    border-radius: 0;
  }
}
.top-round-border {
  border-radius: 4px 4px 0 0;
}
.down-arrow-settings-dropdown {
  position: absolute;
  color: white;
  display: flex;
  height: 100%;
  right: 26px;
  top: 0px;
}
.down-arrow-settings-dropdown:after {
  content: "\\f107";
  position: absolute;
  display: flex;
  font-family: "Font Awesome 7 Free", sans-serif;
  font-weight: 900;
  height: 100%;
  font-size: 2.5rem;
  align-self: center;
}
.up-arrow-settings-dropdown {
  position: absolute;
  color: white;
  display: flex;
  height: 100%;
  right: 26px;
  top: 0px;
}
.up-arrow-settings-dropdown:after {
  content: "\\f106";
  position: absolute;
  display: flex;
  font-family: "Font Awesome 7 Free", sans-serif;
  font-weight: 900;
  height: 100%;
  font-size: 2.5rem;
  align-self: center;
}
.online-directory {
  text-align: left;
  font-size: 2.8rem;
}
.online-directory > li,
.online-directory > li a,
.online-directory > li span {
  text-transform: capitalize;
}
.edit-icon {
  position: absolute;
  right: 0px;
  top: 0px;
  height: 40px;
  width: 40px;
  padding: 7px;
  font-size: 2.4rem;
  cursor: pointer;
}
.edit-icon .fa-lg {
  padding: 0.3em 0;
}
.edit-icon i {
  font-size: 2.4rem;
  vertical-align: top;
}
.editable-description {
  position: relative;
  word-break: break-word;
}
.profile-header {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  width: 36.4rem;
  padding: 1rem;
  float: left;
}
.profile-header label {
  display: block;
  padding-bottom: 1rem;
  font-size: 1.8rem;
  line-height: normal;
  text-transform: none;
}
.show-more-less input[type='checkbox'] {
  display: none;
}
.show-more-less .content {
  overflow: hidden;
  max-height: 100px;
  position: relative;
  line-height: 2rem;
  word-break: break-word;
}
.show-more-less label {
  background: #FFFFFF;
  text-transform: lowercase;
}
.show-more-less label#show_more {
  display: inline-block;
  cursor: pointer;
  position: absolute;
  top: 80px;
  right: 0px;
  left: 0px;
}
.show-more-less label#show_less {
  display: block;
  cursor: pointer;
  position: absolute;
  top: 100%;
  right: 0px;
  left: 0px;
}
.show-more-less input[type='checkbox'] ~ .content label#show_more {
  display: block;
}
.show-more-less input[type='checkbox'] ~ .content label#show_less {
  display: none;
}
.show-more-less input[type='checkbox']:checked ~ .content label#show_more {
  display: none;
}
.show-more-less input[type='checkbox']:checked ~ .content label#show_less {
  display: block;
}
.show-more-less input[type='checkbox']:checked ~ .content {
  max-height: initial;
  overflow: visible;
}
.block-with-text {
  overflow: hidden;
  position: relative;
  line-height: 1.2em;
  max-height: 3.6em;
  text-align: justify;
  margin-right: -1em;
  padding-right: 1em;
}
.block-with-text:before {
  content: '...';
  position: absolute;
  right: 0;
  bottom: 0;
}
.block-with-text:after {
  content: '';
  position: absolute;
  right: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.2em;
  background: white;
}
.logged-in-user-spinner {
  padding: 5px;
  max-width: 50%;
}
.participant-contact-form {
  position: relative;
  padding: 1.5rem;
}
.participant-contact-form > .form-row {
  margin: 2.5rem 0px;
}
.participant-contact-form > .form-row > label {
  margin: 5px 0px;
}
.participant-contact-form > .form-row .icon-container {
  padding: 5px 0px;
}
.participant-contact-form > .form-row .icon-container svg,
.participant-contact-form > .form-row .icon-container label {
  display: inline-block;
  vertical-align: middle;
}
.participant-contact-form > .form-row .icon-container label {
  margin-left: 8px;
}
.participant-contact-form > .form-row input {
  width: 100%;
}
.stand {
  display: inline;
}
.stand .fa,
.stand .fa-solid,
.stand .fa-regular,
.stand .fa-light,
.stand .fa-brands {
  font-size: 2rem;
}
.stand span {
  margin-right: 5px;
}
.stand .stand-name:not(:last-child):after {
  content: ",";
}
.search-bar {
  border: 1px solid #dddddd;
  border-color: #dddddd;
}
.search-bar .input-container {
  margin-right: 67px;
}
.search-bar .input-container input {
  width: 100%;
  display: block;
  border: none;
  padding: 9px 10px;
}
.search-bar button {
  float: right;
  margin: 0px;
}
.search-bar button i {
  font-size: 2.5rem;
}
.profile-image .image-container {
  position: relative;
  width: 180px;
  height: 180px;
  background: #d9d9d9;
  border-radius: 180px;
  overflow: hidden;
}
.profile-image .image-container img {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.switch {
  position: relative;
  display: inline-block;
  width: 140px;
  height: 34px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch input:checked + .slider {
  background-color: #2196F3;
}
.switch input:checked + .slider:before {
  margin-left: calc(100% - 36px);
}
.switch input:checked + .slider .message {
  left: 10px;
  right: auto;
  color: white;
}
.switch input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
.switch .slider {
  z-index: 1;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  width: 140px;
  /* Rounded sliders */
}
.switch .slider .message {
  position: absolute;
  top: 5px;
  left: 36px;
  right: auto;
}
.switch .slider.round {
  border-radius: 34px;
}
.switch .slider.round:before {
  border-radius: 50%;
}
.switch .slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.image-help-text {
  margin: auto;
  margin-top: 43px;
  margin-left: 19px;
  font-size: 1.2rem;
  color: #808080;
}
.image-help-text .icon-container span,
.image-help-text .icon-container i {
  display: inline-block;
  vertical-align: middle;
}
.image-help-text .icon-container i.fa,
.image-help-text .icon-container i.fa-solid,
.image-help-text .icon-container i.fa-regular,
.image-help-text .icon-container i.fa-light,
.image-help-text .icon-container i.fa-brands {
  font-size: 24pt;
  margin-bottom: 0.5rem;
  position: static;
  width: auto;
  color: #2d2d2d;
}
.image-help-text .icon-container span {
  width: calc(100% - 40px);
  margin-left: 0.5rem;
  color: #2d2d2d;
  font-weight: 700;
  font-size: 1.5rem;
}
.empty-content {
  min-height: 10rem;
  border: dashed thin #404040;
  padding: 10px;
  margin-top: 4rem;
}
.form-field-switch-group {
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAIA;EACE,YAAA;AAHF;AAMA;EACE,aAAA;AAJF;AAOA;EACE,aAAA;AALF;AAQA;EACE,aAAA;AANF;AASA;EACE,aAAA;AAPF;AAUA;EACE,aAAA;AARF;AAWA;EACE,aAAA;AATF;AAYA;EACE,iBAAA;AAVF;AAaA;EACE,gBAAA;AAXF;AAcA;EACE,8BAAA;AAZF;AAeA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AAbF;AASA;EAOI,eAAA;AAbJ;AAgBE;EACE,yBAAA;AAdJ;AAkBA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;AAhBF;AAYA;EAOI,qBAAA;EACA,yBAAA;EACA,kBAAA;AAhBJ;AAkBI;EAAA;IACE,yBAAA;EAfJ;AACF;AAqBA;;EACE,kBAAA;AAlBF;AAqBA;EACE,yBAAA;AAnBF;AAuBA;EAJE,yBAAA;EAMA,qBAAA;AArBF;AAwBA;EACE,gCAAA;AAtBF;AAyBA;EACE,6BAAA;AAvBF;AA0BA;EACE,oBAAA;AAxBF;AA2BA;EACE,gBAAA;EACA,oBAAA;EACA,4BAAA;AAzBF;AA4BA;EALE,gBAAA;EACA,oBAAA;EACA,4BAAA;EAKA,qBAAA;AAxBF;AA2BA;EAVE,gBAAA;EACA,oBAAA;EACA,4BAAA;EAUA,qBAAA;AAvBF;AA0BA;EAfE,gBAAA;EACA,oBAAA;EACA,4BAAA;EAeA,qBAAA;AAtBF;AAyBA;EApBE,gBAAA;EACA,oBAAA;EACA,4BAAA;EAoBA,qBAAA;AArBF;AAwBA;EACE,qBAAA;EACA,sBAAA;AAtBF;AAyBA;EACE,qBAAA;EACA,mBAAA;AAvBF;AA0BA;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAxBF;AA2BA;EACE,YAAA;AAzBF;AA4BA;EACE,0BAAA;AA1BF;AA6BA;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;AA3BF;AA8BA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,gCAAA;AA5BF;AA+BA;EACE,YAAA;EACA,WAAA;AA7BF;AA+BE;EA1CA,qBAAA;EACA,mBAAA;EA2CE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EApGF,yBAAA;EAsGE,qBAAA;AA5BJ;AAgCA;EACE,gBAAA;AA9BF;AA6BA;EAII,kBAAA;AA9BJ;AA0BA;;;;;EAOM,gBAAA;EACA,eAAA;AA1BN;AAkBA;EAYM,aAAA;AA3BN;AAeA;;EAiBM,mBAAA;EACA,iBAAA;AA5BN;AAmCI;EACE,kBAAA;AAjCN;AA8BA;EAQI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAnCJ;AAqBA;EA9CE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,gCAAA;EA4DE,WAAA;EACA,gBAAA;EACA,YAAA;AA/BJ;AAmCA;EAhFE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EA6EA,oCAAA;EACA,sBAAA;AA5BF;AAyBA;EAvEE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,gCAAA;EAyEE,WAAA;EACA,gBAAA;EACA,YAAA;AAvBJ;AA4BA;EACE,kBAAA;EACA,mBAAA;EACA,4BAAA;AA1BF;AA4BE;EAxHA,qBAAA;EACA,mBAAA;EAyHE,eAAA;EACA,gBAAA;AAzBJ;AAsBE;;EAMI,cAAA;EACA,gBAAA;AAxBN;AA2BI;;;EACE,cAAA;AAvBN;AAYE;EA7HA,qBAAA;EACA,sBAAA;EA4II,eAAA;EACA,gBAAA;AAvBN;AA2BE;EAAA;IAEI,gBAAA;EAzBJ;EA2BI;IACE,cAAA;IACA,cAAA;IACA,cAAA;EAzBN;AACF;AAgCI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;AA9BN;AAgCI;EACE,cAAA;EACA,eAAA;AA9BN;AA+BM;EAAA;IACE,YAAA;IACA,WAAA;EA5BN;AACF;AA8BI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;AA5BN;AA8BM;EAAA;IACE,WAAA;IACA,aAAA;IACA,iBAAA;IACA,2BAAA;EA3BN;AACF;AA6BI;EACE,kBAAA;AA3BN;AA6BM;EACE,WAAA;EACA,4BAAA;AA3BR;AA8BM;EACE;IACE,WAAA;IACA,4BAAA;EA5BR;AACF;AA+BI;EACE,mBAAA;EACA,eAAA;AA7BN;AA8BM;EACE,kBAAA;AA5BR;AA6BQ;EAAA;IACE,QAAA;EA1BR;AACF;AA6BI;EACE,kBAAA;EACA,mBAAA;AA3BN;AAgCA;EACE,kBAAA;AA9BF;AAgCI;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;AA9BN;AA+BM;EAAA;IACE,WAAA;IACA,kBAAA;EA5BN;AACF;AA8BI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,0BAAA;AA5BN;AA6BM;EACE,aAAA;AA3BR;AA6BM;EAAA;IACE,WAAA;IACA,aAAA;IACA,iBAAA;IACA,2BAAA;EA1BN;AACF;AA2BM;EAAA;IACE,WAAA;IACA,gBAAA;EAxBN;AACF;AA2BI;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;AAzBN;AA0BM;EACE,gBAAA;AAxBR;AA0BM;EACE,WAAA;EACA,cAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAxBR;AAyBQ;EAAA;IACE,UAAA;EAtBR;AACF;AAMI;EAmBI,YAAA;AAtBR;AAwBM;EACE;IACE,WAAA;EAtBR;AACF;AAwBM;EAAA;IACE,WAAA;EArBN;AACF;AAwBI;EACE,mBAAA;EACA,eAAA;AAtBN;AAuBM;EACE,iBAAA;AArBR;AAsBQ;EAAA;IACE,QAAA;EAnBR;AACF;AAsBI;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;AApBN;AAyBA;EA5WE,yBAAA;EA+WE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;AAxBJ;AA2BA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzBF;AA0BE;EAAA;IACE,YAAA;IACA,WAAA;EAvBF;AACF;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AAvBF;AAwBE;EAAA;IACE,WAAA;IACA,gBAAA;EArBF;AACF;AAwBA;EACE,0BAAA;AAtBF;AAyBA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;AAvBF;AAwBE;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,8CAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAtBJ;AA0BA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;AAxBF;AAyBE;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,8CAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAvBJ;AA0BA;EACE,gBAAA;EACA,iBAAA;AAxBF;AA0BI;;;EACE,0BAAA;AAtBN;AA2BA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAzBF;AAiBA;EAWI,gBAAA;AAzBJ;AAcA;EAeI,iBAAA;EACA,mBAAA;AA1BJ;AAqCA;EACE,kBAAA;EACA,sBAAA;AAnCF;AAsCA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;AApCF;AA+BA;EAOI,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;AAnCJ;AAuCA;EAII,aAAA;AAxCJ;AAoCA;EAOI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAxCJ;AA6BA;EAeI,mBAAA;EACA,yBAAA;AAzCJ;AAyBA;EAoBI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AA1CJ;AAiBA;EA6BI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AA3CJ;AASA;EAsCI,cAAA;AA5CJ;AAMA;EA0CI,aAAA;AA7CJ;AAGA;EA8CI,aAAA;AA9CJ;AAAA;EAkDI,cAAA;AA/CJ;AAHA;EAsDI,mBAAA;EACA,iBAAA;AAhDJ;AAqDA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAnDF;AAqDE;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAnDJ;AAqDE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AAnDJ;AAuDA;EACE,YAAA;EACA,cAAA;AArDF;AAwDA;EACE,kBAAA;EACA,eAAA;AAtDF;AAwDE;EACE,kBAAA;AAtDJ;AAwDI;EACE,eAAA;AAtDN;AAkDE;EAQI,gBAAA;AAvDN;AA+CE;;EAWM,qBAAA;EACA,sBAAA;AAtDR;AA0CE;EAgBM,gBAAA;AAvDR;AAuCE;EAqBI,WAAA;AAzDN;AA8DA;EACE,eAAA;AA5DF;AA2DA;;;;;EAII,eAAA;AAxDJ;AAoDA;EAQI,iBAAA;AAzDJ;AA6DI;EACD,YAAA;AA3DH;AAgEA;EAtoBE,yBAAA;EAMA,qBAAA;AAokBF;AA4DA;EAII,kBAAA;AA7DJ;AAyDA;EAOM,WAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AA7DN;AAmDA;EAeI,YAAA;EACA,WAAA;AA/DJ;AA+CA;EAmBM,iBAAA;AA/DN;AAoEA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAlEF;AA4DA;EA3kBE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,gCAAA;AAkhBF;AAmEA;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;AAjEF;AA6DA;EAOI,UAAA;EACA,QAAA;EACA,SAAA;AAjEJ;AAwDA;EAaI,yBAAA;AAlEJ;AAoEI;EACE,8BAAA;AAlEN;AAkDA;EAoBM,UAAA;EACA,WAAA;EACA,YAAA;AAnEN;AA6CA;EA2BI,2BAAA;AArEJ;AA0CA;EA+BI,UAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EAtEF,oBAAoB;AACtB;AA4BA;EA4CM,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AArEN;AAyEI;EACE,mBAAA;AAvEN;AA0EI;EACE,kBAAA;AAxEN;AA2EI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,wBAAA;EACA,gBAAA;AAzEN;AA8EA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AA5EF;AAuEA;;EAtsBE,qBAAA;EACA,sBAAA;AAmoBF;AAkEA;;;;;EAaM,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AAxEN;AAuDA;EAqBM,wBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAzEN;AA8EA;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,gBAAA;AA5EF;AA+EA;EACE,mBAAA;AA7EF","sourcesContent":["@import './constants.less';\n\n//social media\n\n.with-opacity {\n  opacity: 0.3;\n}\n\n.facebook-logo {\n  fill: #3b5998;\n}\n\n.facebook-logo-color {\n  fill: #4267b2;\n}\n\n.twitter-logo-color {\n  fill: #1da1f2;\n}\n\n.youtube-logo-color {\n  fill: #fc0d1c;\n}\n\n.linkedin-logo-color {\n  fill: #0077b5;\n}\n\n.wechat-logo-color {\n  fill: #51c332;\n}\n\n.activation-email {\n  text-align: right;\n}\n\n.activation-email-collapse {\n  text-align: left;\n}\n\n.btn+.btn.activation-email-button {\n  margin-left: 0.8rem !important;\n}\n\n.resend-email-button {\n  background-color: #ffffff;\n  border: solid 1px #a2a2a2;\n  color: #337ab7;\n  font-size: 14px;\n\n  i {\n    font-size: 18px;\n  }\n\n  &:hover {\n    background-color: #e2e6ea;\n  }\n}\n\n.social-media-logo-container {\n  margin-top: 1.5rem;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .social-media-logo {\n    display: inline-block;\n    width: calc(100% * (1/3));\n    margin-bottom: 2em;\n\n    @media (max-width: 992px) and (min-width: 768px) {\n      width: calc(100% * (1/6));\n    }\n  }\n}\n\n//social media ends here\n\n.relative, .editable-container {\n  position: relative;\n}\n\n.border {\n  border: 1px solid @borderColor;\n  // border-radius: @borderRadius;\n}\n\n.darkBorder {\n  .border();\n  border-color: @darkerBorderColor;\n}\n\n.darkBorderBottom {\n  border-bottom: 1px solid @darkerBorderColor;\n}\n\n.darkBorderTop {\n  border-top: 1px solid @darkerBorderColor;\n}\n\n.h2 {\n  margin-bottom: 0.5em;\n}\n\n.multilineOverflow {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n.singleLineOverflow {\n  .multilineOverflow();\n  -webkit-line-clamp: 1;\n}\n\n.twoLinesOverflow {\n  .multilineOverflow();\n  -webkit-line-clamp: 2;\n}\n\n.threeLinesOverflow {\n  .multilineOverflow();\n  -webkit-line-clamp: 3;\n}\n\n.fourLinesOverflow {\n  .multilineOverflow();\n  -webkit-line-clamp: 4;\n}\n\n.verticalMiddle {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.verticalTop {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.algolia-error {\n  display: block;\n  padding: 2em;\n  background: @algoliaErrorBg;\n  text-align: center;\n  color: @errorColor;\n}\n\n.submitting {\n  opacity: 0.6;\n}\n\n[type='file']::-webkit-file-upload-button {\n  -webkit-appearance: button;\n}\n\n.absolute-stretch {\n  display: block;\n  position: absolute;\n  top: 0px;\n  left: 0;\n  bottom: 0px;\n  right: 0px;\n}\n\n.absolute-vertical-center {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.tag-list.participants {\n  padding: 0px;\n  margin: 0px;\n\n  & > li {\n    .verticalTop();\n    padding: 0px 10px;\n    background: @tagBg;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    .border();\n    border-color: @tagBorderColor;\n  }\n}\n\n.file-upload {\n  overflow: hidden;\n\n  .file-upload-wrapper {\n    position: relative;\n\n    .fa, .fa-solid, .fa-regular, .fa-light, .fa-brands {\n      padding: 8px 7px;\n      cursor: pointer;\n    }\n\n    input[type='file'] {\n      display: none;\n    }\n\n    .fa-camera,\n    .fa-upload {\n      vertical-align: top;\n      font-size: 2.4rem;\n    }\n  }\n}\n\n.profile-image {\n  .image-container {\n    &.editable {\n      position: relative;\n    }\n  }\n\n  .file-upload {\n    position: absolute;\n    right: 2px;\n    bottom: 14px;\n    top: auto;\n    font-size: 2.5rem;\n    color: white;\n    border-radius: @borderRadius;\n  }\n\n  .spinner {\n    .absolute-vertical-center();\n    margin: 0px;\n    background: none;\n    border: none;\n  }\n}\n\n.stretchable-spinner {\n  .absolute-stretch();\n  background: rgba(255, 255, 255, 0.3);\n  border: 1px solid gray;\n\n  .spinner {\n    .absolute-vertical-center();\n    margin: 0px;\n    background: none;\n    border: none;\n  }\n}\n\n//user settings panel\n.logged-in-user-settings {\n  text-align: center;\n  margin-bottom: 15px;\n  padding: 20px 20px 20px 20px;\n\n  & > li {\n    .verticalTop();\n    cursor: pointer;\n    padding: 0 0.7em;\n\n    nav, a {\n      display: block;\n      min-height: auto;\n    }\n\n    &, a, span {\n      color: inherit;\n    }\n\n    span {\n      .verticalMiddle();\n      font-size: 2rem;\n      font-weight: 400;\n    }\n  }\n\n  @media (max-width: 768px) {\n    & {\n      text-align: left;\n\n      & > li {\n        display: block;\n        padding: 0.7em;\n        color: inherit;\n      }\n    }\n  }\n}\n\n.settings-navbar-list{\n  .logged-in-user-settings {\n    &__base {\n      position: relative;\n      width: 100%;\n      display: flex;\n      align-items: baseline;\n      justify-content: space-between;\n      flex-wrap: wrap;\n    }\n    &__welcome {\n      display: block;\n      font-size: 25px;\n      @media (min-width: 768px) {\n        flex-grow: 2;\n        width: auto;\n      }\n    }\n    &__list {\n      list-style: none;\n      padding-left: 0;\n      padding-right: 0;\n      width: 100%;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-end;\n\n      @media (min-width: 768px) {\n        width: auto;\n        display: flex;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n      }\n    }\n    &__item {\n      padding-left: 10px;\n\n      &:not(:last-child):after {\n        content: \"\";\n        border-right: 1px solid gray;\n      }\n\n      @media (min-width: 768px) {\n        &:last-child:after {\n          content: \"\";\n          border-right: 1px solid gray;\n        }\n      }\n    }\n    &__link {\n      white-space: nowrap;\n      font-size: 15px;\n      &--logout {\n        padding-left: 10px;\n        @media (min-width: 768px) {\n          order: 3;\n        }\n      }\n    }\n    &__label {\n      padding-left: 10px;\n      padding-right: 10px;\n    }\n  }\n}\n\n.settings-dropdown {\n  position: relative;\n  .logged-in-user-settings{\n    &__dropdown-base {\n      position: absolute;\n      z-index: 1;\n      display: flex;\n      align-items: baseline;\n      justify-content: space-between;\n      flex-wrap: wrap;\n      width: 250px;\n      @media (max-width: 480px) {\n        width: 100%;\n        position: relative;\n      }\n    }\n    &__dropdown-list {\n      list-style: none;\n      padding-left: 0;\n      padding-right: 0;\n      width: 250px;\n      display: flex;\n      flex-direction: column;\n      flex-wrap: wrap;\n      justify-content: flex-end;\n      color: white;\n      border-radius: 0 0 4px 4px;\n      &__hide {\n        display: none;\n      }\n      @media (min-width: 768px) {\n        width: auto;\n        display: flex;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n      }\n      @media (max-width: 480px) {\n        width: 100%;\n        border-radius:0;\n      }\n\n    }\n    &__dropdown-item {\n      padding-left: 15px;\n      width: 250px;\n      margin-bottom: 10px;\n      &:first-child {\n        margin-top: 15px;\n      }\n      &:not(:last-child):after {\n        content: '';\n        display: block;\n        border-bottom: 1px solid white;\n        width: 220px;\n        height: 1px;\n        margin-top: 10px;\n        @media (max-width: 480px) {\n          width: 95%;\n        }\n      }\n      span {\n        color: white;\n      }\n      @media (min-width: 768px) {\n        &:last-child:after {\n          content: \"\";\n        }\n      }\n      @media (max-width: 480px) {\n        width: 100%;\n      }\n\n    }\n    &__dropdown-link {\n      white-space: nowrap;\n      font-size: 15px;\n      &--logout {\n        padding-left: 0px;\n        @media (min-width: 768px) {\n          order: 3;\n        }\n      }\n    }\n    &__dropdown-label {\n      padding-left: 10px;\n      padding-right: 10px;\n      color: white;\n    }\n  }\n}\n\n.participant-dropdown-image {\n  img {\n    .border();\n    border-radius: 180px;\n    width: @loggedInUserSettingsParticipantThumbnailSize;\n    height: @loggedInUserSettingsParticipantThumbnailSize;\n    max-width: @loggedInUserSettingsParticipantThumbnailSize !important;\n  }\n}\n.participant-dropdown-text {\n  color: white;\n  width:100%;\n  height: 18px;\n  margin: 6.5px 35.5px 5.5px 10px;\n  font-size: 15px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  @media (min-width: 768px) {\n    flex-grow: 2;\n    width: auto;\n  }\n}\n.participant-dropdown-container {\n  display: flex;\n  flex-direction: row;\n  width: 250px;\n  height: 43px;\n  padding: 5px 10.5px 10px 15px;\n  object-fit: contain;\n  border-radius: 4px 4px 4px 4px;\n  position: relative;\n  cursor: pointer;\n  @media (max-width: 480px) {\n    width: 100%;\n    border-radius: 0;\n  }\n}\n\n.top-round-border{\n  border-radius: 4px 4px 0 0;\n}\n\n.down-arrow-settings-dropdown {\n  position: absolute;\n  color: white;\n  display: flex;\n  height: 100%;\n  right: 26px;\n  top: 0px;\n  &:after {\n    content: \"\\f107\";\n    position: absolute;\n    display: flex;\n    font-family: \"Font Awesome 7 Free\", sans-serif;\n    font-weight: 900;\n    height: 100%;\n    font-size: 2.5rem;\n    align-self: center;\n  }\n}\n\n.up-arrow-settings-dropdown {\n  position: absolute;\n  color: white;\n  display: flex;\n  height: 100%;\n  right: 26px;\n  top: 0px;\n  &:after{\n    content: \"\\f106\";\n    position: absolute;\n    display: flex;\n    font-family: \"Font Awesome 7 Free\", sans-serif;\n    font-weight: 900;\n    height: 100%;\n    font-size: 2.5rem;\n    align-self: center;\n  }\n}\n.online-directory{\n  text-align: left;\n  font-size: 2.8rem;\n  & > li {\n    &, a, span {\n      text-transform: capitalize;\n    }\n  }\n}\n\n.edit-icon {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  height: 40px;\n  width: 40px;\n  padding: 7px;\n  font-size: 2.4rem;\n  cursor: pointer;\n\n  .fa-lg {\n    padding: .3em 0;\n  }\n\n  i {\n    font-size: 2.4rem;\n    vertical-align: top;\n  }\n  // padding: 0;\n  // font-size: 2.5rem;\n  // border-radius: 3px;\n  // width: 40px;\n  // height: 40px;\n  // line-height: 40px;\n  // text-align: center;\n}\n\n.editable-description {\n  position: relative;\n  word-break: break-word;\n}\n\n.profile-header {\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n  width: 36.4rem;\n  padding: 1rem;\n  float: left;\n  label{\n    display: block;\n    padding-bottom: 1rem;\n    font-size: 1.8rem;\n    line-height: normal;\n    text-transform: none;\n  }\n}\n//show more less\n.show-more-less {\n\n\n  input[type='checkbox'] {\n    display: none;\n  }\n  .content {\n    overflow: hidden;\n    max-height: 100px;\n    position: relative;\n    line-height: 2rem;\n    word-break: break-word;\n  }\n\n  label {\n    background: #FFFFFF;\n    text-transform: lowercase;\n  }\n\n  label#show_more {\n    display: inline-block;\n    cursor: pointer;\n    position: absolute;\n    top: 80px;\n    right:0px;\n    left: 0px;\n  }\n\n  label#show_less {\n    display: block;\n    cursor: pointer;\n    position: absolute;\n    top: 100%;\n    right:0px;\n    left: 0px;\n  }\n\n  input[type='checkbox'] ~ .content label#show_more {\n    display: block;\n  }\n\n  input[type='checkbox'] ~ .content label#show_less {\n    display: none;\n  }\n\n  input[type='checkbox']:checked ~ .content label#show_more {\n    display: none;\n  }\n\n  input[type='checkbox']:checked ~ .content label#show_less {\n    display: block;\n  }\n\n  input[type='checkbox']:checked ~ .content {\n    max-height: initial;\n    overflow:visible;\n  }\n}\n\n//three-line-overflow\n.block-with-text {\n  overflow: hidden;\n  position: relative;\n  line-height: 1.2em;\n  max-height: 3.6em;\n  text-align: justify;\n  margin-right: -1em;\n  padding-right: 1em;\n\n  &:before {\n    content: '...';\n    position: absolute;\n    right: 0;\n    bottom: 0;\n  }\n  &:after {\n    content: '';\n    position: absolute;\n    right: 0;\n    width: 1em;\n    height: 1em;\n    margin-top: 0.2em;\n    background: white;\n  }\n}\n\n.logged-in-user-spinner {\n  padding: 5px;\n  max-width: 50%;\n}\n\n.participant-contact-form {\n  position: relative;\n  padding: 1.5rem;\n\n  & > .form-row {\n    margin: 2.5rem 0px;\n\n    & > label {\n      margin: 5px 0px;\n    }\n\n    .icon-container {\n      padding: 5px 0px;\n\n      svg, label {\n        display: inline-block;\n        vertical-align: middle;\n      }\n\n      label {\n        margin-left: 8px;\n      }\n    }\n\n    input {\n      width: 100%;\n    }\n  }\n}\n\n.stand {\n  display: inline;\n\n  .fa, .fa-solid, .fa-regular, .fa-light, .fa-brands {\n    font-size: 2rem;\n  }\n\n  span {\n    margin-right: 5px;\n  }\n\n  .stand-name:not(:last-child) {\n    &:after {\n\t\t\tcontent:\",\";\n\t\t}\n  }\n}\n\n.search-bar {\n  .darkBorder();\n\n  .input-container {\n    margin-right: 67px;\n\n    input {\n      width: 100%;\n      display: block;\n      border: none;\n      padding: 9px 10px;\n    }\n  }\n\n  button {\n    float: right;\n    margin: 0px;\n\n    i {\n      font-size: 2.5rem;\n    }\n  }\n}\n\n.profile-image .image-container {\n  position: relative;\n  width: @participantProfileImageSize;\n  height: @participantProfileImageSize;\n  background: @defaultProfileImageBg;\n  border-radius: @participantProfileImageSize;\n  overflow: hidden;\n\n  img {\n    .absolute-vertical-center();\n  }\n}\n\n//switch\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 140px;\n  height: 34px;\n\n  input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n\n  input:checked+.slider {\n    background-color: #2196F3;\n\n    &:before {\n      margin-left: calc(100% - 36px);\n    }\n\n    .message {\n      left: 10px;\n      right: auto;\n      color: white;\n    }\n  }\n\n  input:focus+.slider {\n    box-shadow: 0 0 1px #2196F3;\n  }\n\n  .slider {\n    z-index: 1;\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: .4s;\n    transition: .4s;\n    width: 140px;\n\n    .message {\n      position: absolute;\n      top: 5px;\n      left: 36px;\n      right: auto;\n    }\n\n    /* Rounded sliders */\n    &.round {\n      border-radius: 34px;\n    }\n\n    &.round:before {\n      border-radius: 50%;\n    }\n\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 26px;\n      width: 26px;\n      left: 4px;\n      bottom: 4px;\n      background-color: white;\n      -webkit-transition: .4s;\n      transition: .4s;\n    }\n  }\n}\n\n.image-help-text {\n  margin: auto;\n  margin-top: 43px;\n  margin-left: 19px;\n  font-size: 1.2rem;\n  color: @greyFontColor;\n\n  .icon-container {\n    span, i {\n      .verticalMiddle();\n    }\n\n    i.fa, i.fa-solid, i.fa-regular, i.fa-light, i.fa-brands {\n      font-size: 24pt;\n      margin-bottom: .5rem;\n      position: static;\n      width: auto;\n      color: @participantProfileColor;\n    }\n\n    span {\n      width: calc(100% - 40px);\n      margin-left: .5rem;\n      color: @participantProfileColor;\n      font-weight: 700;\n      font-size: 1.5rem;\n    }\n  }\n}\n\n.empty-content {\n  min-height: 10rem;\n  border: dashed thin #404040;\n  padding: 10px;\n  margin-top: 4rem;\n}\n\n.form-field-switch-group {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
